import React, {
  ReactElement,
  useCallback,
  useMemo,
  useRef,
  useState,
  useEffect,
} from "react";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
  convertFromRaw,
  Modifier,
  RichUtils,
} from "draft-js";
import Editor from "@draft-js-plugins/editor";
import { stateToHTML } from "draft-js-export-html";
import createMentionPlugin, {
  defaultSuggestionsFilter,
} from "@draft-js-plugins/mention";
import StaticToolbar, {
  toolbarPlugin,
} from "../../../components/editor/StaticToolbarEdit";
import createLinkifyPlugin, { extractLinks } from "@draft-js-plugins/linkify";
import editorStyles from "../../../components/note_details/SimpleMentionEditor.module.css";
import "@draft-js-plugins/mention/lib/plugin.css";
import Modal from "./Modal";
import ImagePreview from "../ImagePreview";
import * as commonData from "../../../Common";
import RModal from "react-bootstrap/Modal";
import axios from "axios";
import { Alert } from "react-bootstrap";

const styles = {
  link: {
    color: "blue",
    textDecoration: "underline",
  },
};

const Link = (props) => {
  const { contentState, entityKey } = props;
  const { url } = contentState.getEntity(entityKey).getData();
  return (
    <a href={url} style={styles.link}>
      {props.children}
    </a>
  );
};

const findLinkEntities = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === "LINK"
    );
  }, callback);
};

const LinkDecorator = {
  strategy: findLinkEntities,
  component: Link,
};
let newarrayAll = [];
const EditNote = (props) => {
  const { note_content, value, users: propsUser } = props;
  const ref = useRef(null);
  const [state, setState] = useState({
    editorState: EditorState.createEmpty(),
    suggestions: [],
    open: false,
    noteerror: "",
    editorEmpty: "",
    addMention: [],
    selectedText: "",
    imageFailedError: [],
    insertText: "",
    insertUrlText: "",
    insertUrl: false,
    errors: {},
    images: [],
    attachShow: false,
    attachImages: {},
    attachments: [],
    mainImageUpload: false,
    editNoteContent: {},
    removeAttachment: [],
    html: "",
    note_content_json: "",
    mention: [],
    isUpdate: false,
  });
  const convertToDraftjsCode = (value) => {
    if (value) {
      const blocksFromHTML = convertFromHTML(value);
      const state = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      return state;
    }
  };
  useEffect(() => {
    try {
      const editNote = commonData.IsJsonString(value)
        ? convertFromRaw(JSON.parse(value || {}))
        : convertToDraftjsCode(value);
      if (editNote) {
        let newEditNoteValues = EditorState.createWithContent(editNote);

        setState((state) => {
          return {
            ...state,
            editorState: newEditNoteValues,
          };
        });
      }
      let usersTransform = Object.keys(propsUser).map((key) => ({
        name: propsUser[key]?.name,
        email: propsUser[key]?.email,
        avatar: propsUser[key]?.profile_image,
        user_uuid: key,
      }));

      setState((state) => {
        return {
          ...state,
          suggestions: usersTransform,
          editNoteContent: props.editNote,
        };
      });
    } catch (err) {
      console.log(err);
    }
  }, [value, propsUser, props]);

  function customStateToHTML(contentState) {
    const options = {
      defaultBlockTag: "div",
      blockStyleFn: (block) => {
        const type = block.getType();
        if (type === "paragraph") {
          return { element: "p", attributes: { style: { margin: "0" } } };
        }
        return null;
      },
    };
    return stateToHTML(contentState, options);
  }

  const { MentionSuggestions, plugins } = useMemo(() => {
    const mentionPlugin = createMentionPlugin({
      supportWhitespace: true,
      mentionPrefix: "@",
    });
    const { MentionSuggestions } = mentionPlugin;
    let linkifyPlugin = createLinkifyPlugin();
    const plugins = [
      mentionPlugin,
      StaticToolbar,
      toolbarPlugin,
      linkifyPlugin,
    ];
    return { plugins, MentionSuggestions };
  }, []);
  const handlePastedText = (text, html, editorState) => {
    return html;
  };
  const onChange = (editorState) => {
    setState((prevState) => {
      return {
        ...prevState,
        editorState: editorState,
        editorEmpty: "",
      };
    });
    const contentcheck = editorState.getCurrentContent();
    const rowContent = convertToRaw(contentcheck);
    const plainText = rowContent.blocks
      .map((block) => block.text.trim())
      .join("");
    // props.onChangeValidation(plainText);
    const newcontent = JSON.stringify(
      convertToRaw(state.editorState.getCurrentContent())
    );
    let note_content_json = newcontent;
    let html = customStateToHTML(state.editorState.getCurrentContent());
    const currentContent = editorState.getCurrentContent();
    const currentSelection = editorState.getSelection();
    const isBackward = currentSelection.getIsBackward();

    let selectedText;
    if (isBackward) {
      selectedText = editorState
        .getCurrentContent()
        .getBlockForKey(currentSelection.getStartKey())
        .getText()
        .slice(
          currentSelection.getFocusOffset(),
          currentSelection.getAnchorOffset()
        );
      setState((state) => {
        return {
          ...state,
          errors: {},
        };
      });
    } else {
      selectedText = editorState
        .getCurrentContent()
        .getBlockForKey(currentSelection.getStartKey())
        .getText()
        .slice(
          currentSelection.getAnchorOffset(),
          currentSelection.getFocusOffset()
        );
      setState((state) => {
        return {
          ...state,
          errors: {},
        };
      });
    }
    // const selectedText = editorState
    //   .getCurrentContent()
    //   .getBlockForKey(selection.getStartKey())
    //   .getText()
    //   .slice(selection.getAnchorOffset(), selection.getFocusOffset());
    setState((prevState) => {
      return {
        ...prevState,
        selectedText: selectedText,
        insertText: selectedText,
      };
    });
    const mentions = convertToRaw(state.editorState.getCurrentContent());
    const mentionmap = mentions["entityMap"];
    const mention = [];
    const mentions_data = [];
    for (let i in mentionmap) {
      const ind = mention.findIndex(
        (item) => item?.email === mentionmap[i].data.mention?.email
      );

      if (ind === -1) {
        mention.push(mentionmap?.[i]?.data?.mention?.user_uuid);
      }
    }

    const raw = convertToRaw(state.editorState.getCurrentContent());
    const { blocks, entityMap } = raw;
    Object.values(entityMap).map((entity) => {
      if (entity.data.mention !== undefined) {
        mentions_data.push(entity.data.mention);
      }
    });

    if (mentions_data !== null && mentions_data.length > 0) {
      mentions_data.forEach((item) => {
        const replace_data = `@${item.name}`;
        if (propsUser[item.user_uuid].profile_url) {
          const regex = new RegExp(replace_data.replace("&", "&amp;"), "g"); // Adjusting for &amp;
          html = html.replaceAll(
            regex,
            `<a target='_blank' href="${
              propsUser[item.user_uuid]?.profile_url
            }">@${item.name}</a>`
          );
        } else {
          const regex = new RegExp(replace_data.replace("&", "&amp;"), "g"); // Adjusting for &amp;
          html = html.replaceAll(
            regex,
            `<a target='_blank' href="/user/${item.user_uuid}">@${item.name}</a>`
          );
        }
      });
    }

    const linkifys = extractLinks(html);
    const parser = new DOMParser();
    // if (linkifys != null && linkifys.length > 0) {
    //   const doc = parser.parseFromString(html, "text/html");
    //   const aTags = doc.getElementsByTagName("a");

    const doc = parser.parseFromString(html, "text/html");
    // const brTags = doc.querySelectorAll("br");
    // brTags.forEach((ele) => ele.remove());

    html = doc.body.innerHTML;

    // props.getValidData(plainText);
    setState((state) => {
      return {
        ...state,
        html,
        note_content_json,
        mention,
      };
    });
    // if (props.editNote && plainText.length > 0) {
    //   props.getRawDataOnchange(html, note_content_json, mention);
    // }
  };
  const hideUiModal = () => {
    setState((state) => {
      return {
        ...state,
        attachShow: false,
      };
    });
  };

  const onHideText = () => {
    setState((prevState) => {
      return {
        ...prevState,
        insertUrl: false,
        insertText: "",
        insertUrlText: "",
        selectedText: "",
        errors: {},
      };
    });
  };
  const isEditorEmpty = () => {
    const contentState = state.editorState.getCurrentContent();
    return contentState.getPlainText().trim().length == 0;
  };

  const onSubmitHandler = async (evt) => {
    evt.preventDefault();
    if (!isEditorEmpty()) {
      setState((state) => {
        return {
          ...state,
          isUpdate: true,
          editorEmpty: "",
        };
      });
      let newImagesTransforms = {
        ...state.attachImages,
        ...state.editNoteContent.attachment,
      };

      const respdata = await props.submitNote(
        state.html,
        state.note_content_json,
        props?.editNote._id,
        props?.editNote.custom_note_uuid,
        state.mention,
        state.removeAttachment,
        newImagesTransforms
      );

      if (respdata.code === 200) {
        setState((state) => {
          return {
            ...state,
            attachImages: {},
            isUpdate: false,
          };
        });
      }
    } else {
      setState((state) => {
        return {
          ...state,
          editorEmpty: "Note shouldn't be blank",
        };
      });
    }
  };
  const removeNoteImages = (ind) => {
    const newimage = {
      ...delete state.attachImages[ind],
      ...state.attachImages,
    };
    setState((state) => {
      return {
        ...state,
        attachImages: newimage,
      };
    });
  };

  const getBlobImages = (images, ind) => {
    const blob = images?.file_url;
    const ext = images?.file_name?.split(".").pop();
    const allow_images = ["jpg", "png", "jpeg"];

    return (
      <div class="img-box">
        {allow_images.includes(ext) ? (
          <img
            src={blob}
            class="img-fluid"
            style={{ width: "120px", height: "55px" }}
            // onClick={() => this.previewImage(blob)}
          />
        ) : (
          <i className="fa fa-file" style={{ fontSize: "40px" }}></i>
        )}

        <figure>
          {images?.file_name?.slice(0, 6) +
            "..." +
            images?.file_name?.slice(images?.file_name.length - 1, 6) +
            "." +
            ext}
        </figure>
        <div class="delete" onClick={() => removeNoteImages(ind)}>
          <svg
            width="11"
            height="10"
            viewBox="0 0 11 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Remove</title>
            <path
              d="M8.21973 2.5L3.21973 7.5"
              stroke="#737373"
              stroke-width="1.33"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M3.21973 2.5L8.21973 7.5"
              stroke="#737373"
              stroke-width="1.33"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </div>
      </div>
    );
  };

  const getImageHandler = async (images) => {
    newarrayAll = [];
    setState((state) => {
      return {
        ...state,
        attachShow: true,
        attachments: [],
      };
    });
  };

  const onUrlInsert = () => {
    setState((prevState) => {
      return {
        ...prevState,
        insertUrl: true,
      };
    });
  };
  const deleteEditAttachment = (id) => {
    const removeAttachment = { ...state.editNoteContent };
    const ids = [...state.removeAttachment, id];
    if (removeAttachment.hasOwnProperty("attachment")) {
      const attachment = {
        ...delete removeAttachment.attachment[id],
        ...removeAttachment.attachment,
      };
      setState((state) => {
        return {
          ...state,
          editNoteContent: removeAttachment,
          removeAttachment: ids,
        };
      });
    }
  };
  const onClick = () => {
    if (
      convertToRaw(state.editorState.getCurrentContent()).blocks.length === 1 &&
      convertToRaw(
        state.editorState.getCurrentContent()
      ).blocks[0].text.trim() === ""
    ) {
      editNoteref.current?.focus();
      setState((prevState) => {
        return {
          ...prevState,
          noteerror: "Note shouldn't be blank",
        };
      });
      return false;
    } else {
      // const html = stateToHTML(this.state.editorState.getCurrentContent());
      const raw = convertToRaw(state.editorState.getCurrentContent());
      const draft_js_content = JSON.stringify(raw);
      const { blocks, entityMap } = raw;
      let content = "";
      Object.keys(blocks).map((i) => {
        const { entityRanges, text } = blocks[i];
        const textLength = text.length;

        let startRange = 0;
        entityRanges.map((range) => {
          content += text.substr(startRange, range.offset - startRange);
          content += '<a href="">';
          content += text.substr(range.offset, range.length);
          content += "</a>";
          startRange = range.offset + range.length;
        });
        content += text.substr(startRange, textLength);
        content += "\r\n";
      });
      const html = content;
      props.getRawData(draft_js_content);
      setState((prevState) => {
        return {
          ...prevState,
          editorState: EditorState.createEmpty(),
          noteerror: "",
        };
      });
    }
  };

  const onSearchChange = useCallback(
    ({ value }) => {
      setState((prevState) => {
        return {
          ...prevState,
          suggestions: defaultSuggestionsFilter(
            value,
            Object.keys(propsUser)
              .filter((ite) => propsUser[ite]?.is_active == 1)
              .map((item, index) => ({
                name: propsUser[item]?.name,
                email: propsUser[item]?.email,
                avatar: propsUser[item]?.profile_image,
                user_uuid: item,
              }))
          ),
        };
      });
    },
    [state]
  );

  const onOpenChange = useCallback((open) => {
    setState((prevState) => {
      return {
        ...prevState,
        open,
      };
    });
  }, []);
  const addHttp = (url) => {
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      return "http://" + url;
    }
    return url;
  };
  const insertUrlLink = () => {
    if (validate()) {
      setState((prevState) => {
        return {
          ...prevState,
          insertUrl: false,
        };
      });
      const url = addHttp(state.insertUrlText);
      const contentState = state.editorState.getCurrentContent();
      const selection = state.editorState.getSelection();
      const entityKey = contentState
        .createEntity("LINK", "MUTABLE", { url })
        .getLastCreatedEntityKey();
      const block = contentState.getBlockForKey(selection.getStartKey());
      const start = selection.getStartOffset();
      const end = selection.getEndOffset();
      const blockText = block.getText().slice(start, end);

      const contentWithLink = Modifier.replaceText(
        contentState,
        selection,
        state.insertText || blockText,
        null,
        entityKey
      );

      const newEditorState = EditorState.push(
        state.editorState,
        contentWithLink,
        "insert-characters"
      );

      const ddeTe = EditorState.forceSelection(
        newEditorState,
        contentWithLink.getSelectionAfter()
      );
      setState((prevState) => {
        return {
          ...prevState,
          editorState: ddeTe,
          insertText: "",
          insertUrlText: "",
        };
      });
    }
  };
  const validate = (evt) => {
    let errors = {};

    if (!state.insertText.trim()) {
      errors["insertText"] = "Please enter URL text";
    } else {
      errors["insertText"] = "";
    }

    if (!state.insertUrlText.trim()) {
      //url validation
      errors["insertUrlText"] = "Please enter URL";
    } else {
      errors["insertUrlText"] = "";
    }
    // const pattern = new RegExp(
    //   "^(https?:\\/\\/)?" + // protocol
    //     "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
    //     "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
    //     "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
    //     "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
    //     "(\\#[-a-z\\d_]*)?$",
    //   "i"
    // ); // fragment locator
    let pattern = /^(ftp|http|https):\/\/[^ "]+$/;

    if (state.insertUrlText && !pattern.test(state.insertUrlText)) {
      errors["insertUrlText"] = "Please enter valid URL";
    }

    if (errors.insertText || errors.insertUrlText) {
      setState((prevState) => {
        return {
          ...prevState,
          errors: { ...state.errors, ...errors },
        };
      });
      return false;
    }
    setState((prevState) => {
      return {
        ...prevState,
        errors: { ...state.errors, ...errors },
      };
    });

    return true;
  };
  const removeImageHandler = (index, name) => {
    const attachments = [...state.attachments];
    attachments.splice(index, 1);
    const alertError = [...newarrayAll];
    const indexr = alertError.findIndex((item) => item.name === name);
    alertError.splice(indexr, 1);
    newarrayAll = alertError;
    setState((state) => {
      return {
        ...state,
        attachments,
      };
    });
  };
  const attachmentUploadHandler = (evt) => {
    const files = evt.target.files;
    const attachments = [...state.attachments];
    for (let i = 0; i < files.length; i++) {
      attachments.push(files[i]);
    }
    setState((state) => {
      return {
        ...state,
        attachments,
      };
    });
  };

  const newPromiseUploader = (formdata) => {
    let newarr = [];
    const data = commonData.getCommonData();
    return new Promise((resolve, reject) => {
      axios
        .post(`${data.apiUrl}attachment/upload`, formdata, {
          headers: {
            "Content-Type": "multipart/formdata",
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            resolve(resp);
          } else {
            reject(resp);
          }
        })
        .catch((error) => {
          const arrnewcon = [...newarrayAll];
          if (arrnewcon.length > 0) {
            let newfile = arrnewcon.find((item) => {
              return (
                item.name.toLowerCase() ===
                formdata.get("image").name.toLowerCase()
              );
            });
            if (!newfile) {
              getStoreData({
                name: formdata.get("image").name,
                message: error.message,
              });
            }
          } else {
            getStoreData({
              name: formdata.get("image").name,
              message: error.message,
            });
          }
          reject(error);
        });
    });
  };

  const getStoreData = (obj) => {
    const failedImagesIssue = [...newarrayAll];
    failedImagesIssue.push(obj);
    newarrayAll = failedImagesIssue;
  };

  const onSubmitAttachmentHandler = async (evt) => {
    evt.preventDefault();
    if (state.attachments.length > 0) {
      setState((state) => {
        return {
          ...state,
          mainImageUpload: true,
        };
      });
      const data = commonData.getCommonData();
      let newarray = [];
      const appPromis = state.attachments.map((file) => {
        let formdata = new FormData();
        formdata.append("app_token", data.app_token);
        formdata.append("product_key", process.env.REACT_APP_PRODUCT_KEY);
        formdata.append(`image`, file);
        const result = newPromiseUploader(formdata);
        result.then((resp) => {
          if (resp.data.code === 400 || resp.data.code === 1208) {
            const arrnewcon = [...newarrayAll];
            if (arrnewcon.length > 0) {
              let newfile = arrnewcon.find((item) => {
                return item.name.toLowerCase() === file.name.toLowerCase();
              });
              if (!newfile) {
                getStoreData({
                  name: file.name,
                  message: resp.data.message,
                });
              }
              // return;
            } else {
              getStoreData({
                name: file.name,
                message: resp.data.message,
              });
            }
          }
        });
        return result;
      });

      const request = await Promise.allSettled(appPromis);
      if (request.length > 0) {
        let newfilearray = {};
        request.forEach((it) => {
          if (it.status === "fulfilled") {
            const {
              data: { data },
            } = it.value;
            newfilearray = { ...newfilearray, ...data };
          } else {
          }
        });

        if (
          newfilearray &&
          request.every(
            (item) =>
              item.status === "fulfilled" && item.value.data.code === 200
          )
        ) {
          setTimeout(() => {
            setState((state) => {
              return {
                ...state,
                attachments: [],
                attachImages: newfilearray,
                attachShow: false,
                mainImageUpload: false,
              };
            });
          }, 200);

          // this.props.saveAttachment({ attachments: newfilearray });
          // this.props.updateAttachment({
          //   attachment: newfilearray,
          //   app_token: this.state.boarddata.app_token,
          //   attribute_set_key: this.props.match.params.attribute_set_key,
          //   customer_tattle_uuid: +this.props.match.params.id,
          // });
        } else {
          setState((state) => {
            return { ...state, attachShow: true, mainImageUpload: false };
          });
        }
      }
    }
  };

  const getModalContent = () => {
    return (
      <>
        <form onSubmit={onSubmitAttachmentHandler}>
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div className="file-select">
                <div className="file-select-name" id="noFile2">
                  <div>
                    <svg
                      width="26"
                      height="26"
                      viewBox="0 0 26 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.4966 2.21875C10.6066 2.25362 7.84482 3.41715 5.80115 5.46082C3.75748 7.50449 2.59395 10.2663 2.55908 13.1562C2.59395 16.0462 3.75748 18.808 5.80115 20.8517C7.84482 22.8953 10.6066 24.0589 13.4966 24.0938C16.3866 24.0589 19.1483 22.8953 21.192 20.8517C23.2357 18.808 24.3992 16.0462 24.4341 13.1562C24.3992 10.2663 23.2357 7.50449 21.192 5.46082C19.1483 3.41715 16.3866 2.25362 13.4966 2.21875ZM19.7466 13.9375H14.2778V19.4062H12.7153V13.9375H7.24658V12.375H12.7153V6.90625H14.2778V12.375H19.7466V13.9375Z"
                        fill="#717171"
                      ></path>
                    </svg>
                  </div>
                  Add File
                </div>
                <input
                  type="file"
                  name="chooseFile"
                  id=""
                  title=""
                  multiple
                  onChange={attachmentUploadHandler}
                />
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div className="custom_image">
                <div className="afterupload-image">
                  {state.attachments.map((file, index) => {
                    const imgg = URL.createObjectURL(file);
                    return (
                      <div class="img-box">
                        <ImagePreview
                          headImage={imgg}
                          ext={file.name.split(".").pop()}
                          imgLength={state.attachments}
                          width="128px"
                          height="58px"
                        />

                        <figure>
                          {file?.name?.slice(0, 6) +
                            "." +
                            file?.name.split(".").pop()}
                        </figure>
                        <div
                          class="delete"
                          onClick={() => removeImageHandler(index, file.name)}
                        >
                          <svg
                            width="11"
                            height="10"
                            viewBox="0 0 11 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <title>Remove</title>
                            <path
                              d="M8.21973 2.5L3.21973 7.5"
                              stroke="#737373"
                              stroke-width="1.33"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                            <path
                              d="M3.21973 2.5L8.21973 7.5"
                              stroke="#737373"
                              stroke-width="1.33"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                          </svg>
                        </div>
                      </div>
                    );
                  })}
                </div>
                {newarrayAll.length > 0 && (
                  <div className="image_failed_list">
                    {" "}
                    <ul>
                      {newarrayAll.map((item, index) => (
                        <li>
                          <Alert variant="danger">
                            {item.name} : {item.message}
                          </Alert>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="cancl-cls"
              data-bs-dismiss="modal"
              onClick={hideUiModal}
            >
              Cancel
            </button>
            <button type="submit" className="submit-cls">
              {state.mainImageUpload ? "Uploading..." : "Submit"}
            </button>
          </div>
        </form>
      </>
    );
  };

  const insertLinkHandler = (event) => {
    setState((state) => {
      return {
        ...state,
        [event.target.name]: event.target.value,
      };
    });
    validate(event);
  };
  useEffect(() => {
    // const pattern = new RegExp(
    //   "^(https?:\\/\\/)?" + // protocol
    //     "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
    //     "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
    //     "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
    //     "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
    //     "(\\#[-a-z\\d_]*)?$",
    //   "i"
    // ); // fragment locator

    const pattern = /^(ftp|http|https):\/\/[^ "]+$/;

    const errors = {
      ...state.errors,
    };
    if (state.insertUrlText && !pattern.test(state.insertUrlText)) {
      errors["insertUrlText"] = "Please enter valid URL";
    } else {
      errors["insertUrlText"] = "";
    }
    setState((state) => {
      return {
        ...state,
        errors,
      };
    });
  }, [state.insertUrlText]);

  const onAddMention = () => {};
  const handlePaste = (event) => {
    event.preventDefault();
    const pastedValue = event.clipboardData.getData("text");
    setState((state) => {
      return {
        ...state,
        [event.target.name]: pastedValue,
      };
    });

    validate(event);
  };
  return (
    <>
      <Modal
        show={state.attachShow}
        className="tattle-Uppopup"
        close={hideUiModal}
        backdropClassName="editFilebackdrop"
      >
        {getModalContent()}
      </Modal>
      <Modal show={state.insertUrl} close={onHideText}>
        <div className="form-group">
          {!state.selectedText && (
            <>
              <label>Text</label>
              <input
                type="text"
                className="form-control"
                onChange={insertLinkHandler}
                value={state.insertText}
                name="insertText"
                placeholder="Link text"
              />
            </>
          )}
          <div className="error">
            {state.errors["insertText"] && state.errors["insertText"]}
          </div>
        </div>

        <div className="form-group">
          <label>URL</label>
          <input
            type="text"
            className="form-control"
            onChange={insertLinkHandler}
            name="insertUrlText"
            value={state.insertUrlText}
            placeholder="http://"
            onPaste={handlePaste}
          />
          <div className="error">
            {state.errors["insertUrlText"] && state.errors["insertUrlText"]}
          </div>
        </div>
        <button
          className="muBtn _blue mt-3 float-end"
          type="button"
          onClick={insertUrlLink}
        >
          OK
        </button>
      </Modal>
      <RModal
        show={props.show}
        onHide={props.hideUiModal}
        centered
        className="edit-Modal"
      >
        <RModal.Header closeButton>
          <RModal.Title>
            Edit note of : {propsUser[props?.editNote?.user_uuid]?.name}
          </RModal.Title>
        </RModal.Header>
        <RModal.Body>
          {state.editorEmpty && (
            <div class="invalid-feedback" style={{ display: "block" }}>
              Note shouldn't be blank
            </div>
          )}
          <div
            className={editorStyles.editor}
            onClick={() => {
              ref.current.focus();
            }}
          >
            <Editor
              editorKey={"editor"}
              editorState={state.editorState}
              onChange={onChange}
              decorators={[LinkDecorator]}
              plugins={plugins}
              placeholder={"Type to add your note..."}
              ref={ref}
              handlePastedText={handlePastedText}
            />
            <MentionSuggestions
              open={state.open}
              onOpenChange={onOpenChange}
              suggestions={state.suggestions}
              onSearchChange={onSearchChange}
              onAddMention={onAddMention}
            />
          </div>
          <div className="allTools">
            <div className="check-toolbar">
              <StaticToolbar
                getImages={getImageHandler}
                fileFalse={true}
                toggleLink={onUrlInsert}
              />{" "}
              {props.addnote && (
                <button
                  className="muBtn _blue float-end"
                  title="Submit"
                  onClick={onClick}
                >
                  Add Note
                </button>
              )}
            </div>
          </div>{" "}
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div className="custom_image">
              <div class="afterupload-image">
                {state.editNoteContent.hasOwnProperty("attachment") &&
                  Object?.keys(state.editNoteContent?.attachment).map((it) => {
                    return (
                      <div class="img-box edit_note">
                        <ImagePreview
                          ext={state.editNoteContent?.attachment[it].file_name
                            .split(".")
                            .pop()}
                          headImage={state.editNoteContent?.attachment[it]}
                          width="120px"
                          height="58px"
                        />

                        <div class="delete">
                          <svg
                            width="11"
                            height="10"
                            viewBox="0 0 11 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            onClick={() =>
                              deleteEditAttachment(
                                state.editNoteContent?.attachment[it].file_uuid
                              )
                            }
                          >
                            <title>Remove</title>
                            <path
                              d="M8.21973 2.5L3.21973 7.5"
                              stroke="#737373"
                              stroke-width="1.33"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                            <path
                              d="M3.21973 2.5L8.21973 7.5"
                              stroke="#737373"
                              stroke-width="1.33"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                          </svg>
                        </div>
                      </div>
                    );
                  })}
                {state.attachImages &&
                  Object.keys(state.attachImages).length > 0 &&
                  state.attachImages &&
                  Object.keys(state.attachImages).map((item, ii) => {
                    return getBlobImages(state.attachImages[item], item);
                  })}
              </div>
            </div>
          </div>
        </RModal.Body>
        <RModal.Footer>
          <form onSubmit={onSubmitHandler}>
            <button
              type="button"
              className="cancl-cls"
              data-bs-dismiss="modal"
              onClick={props.hideUiModal}
            >
              Cancel
            </button>
            &nbsp; &nbsp;
            <button
              type="submit"
              className="submit-cls"
              disabled={state.isUpdate}
            >
              {state.isUpdate ? "Updating..." : "Update"}
            </button>
          </form>
        </RModal.Footer>
      </RModal>
    </>
  );
};

export default EditNote;
